import { render, staticRenderFns } from "./loginRegisterDialog.vue?vue&type=template&id=50aab1d6&scoped=true&"
import script from "./loginRegisterDialog.vue?vue&type=script&lang=ts&"
export * from "./loginRegisterDialog.vue?vue&type=script&lang=ts&"
import style0 from "./loginRegisterDialog.vue?vue&type=style&index=0&id=50aab1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aab1d6",
  null
  
)

export default component.exports